import { Modal } from '@/core/components/modal'
import { Button } from '@c/button'
import {
  Form,
  TextField,
  Button as SubmitButton,
  drfFetch,
  login,
} from '@/core'

import styles from './style.module.less'

export const ModalConfirm = ({
  name,
  message,
  info,
  onClickCancel,
  form,
  cancelVariant = 'secondary',
  confirm = 'Yes',
  cancel = 'Cancel',
  size = 'med',
}) => (
  <Modal className={size} name={name}>
    <div className={styles.modalConfirm}>
      <h2>{message}</h2>
      {!!info && <div className={styles.info}>{info}</div>}
      <Form {...form} className={styles.form}>
        <div className={styles.modalActions}>
          <Button variant={cancelVariant} onClick={onClickCancel}>
            {cancel}
          </Button>
          <SubmitButton enabled>{confirm}</SubmitButton>
        </div>
      </Form>
    </div>
  </Modal>
)
